export const mapFreeTrialPriceFromCartPrices = (cart) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
    const item = ((_a = cart.items) === null || _a === void 0 ? void 0 : _a[0]) || null;
    const totalAfterTrial = (_d = (_c = (_b = cart.totalAfterTrial) === null || _b === void 0 ? void 0 : _b.total) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 0;
    const totalAfterTrialInclTax = (_g = (_f = (_e = cart.totalAfterTrial) === null || _e === void 0 ? void 0 : _e.totalInclTax) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : 0;
    const grandTotal = (_h = cart.prices) === null || _h === void 0 ? void 0 : _h.grandTotal;
    const subtotal = (_l = (_k = (_j = cart.totalIncludingTrial) === null || _j === void 0 ? void 0 : _j.totalInclTax) === null || _k === void 0 ? void 0 : _k.value) !== null && _l !== void 0 ? _l : 0;
    const deposit = (_p = (_o = (_m = cart.prices) === null || _m === void 0 ? void 0 : _m.subtotalIncludingTax) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : 0;
    const discount = (_u = (_t = (_s = (_r = (_q = item === null || item === void 0 ? void 0 : item.product) === null || _q === void 0 ? void 0 : _q.priceRange) === null || _r === void 0 ? void 0 : _r.minimumPrice) === null || _s === void 0 ? void 0 : _s.discount) === null || _t === void 0 ? void 0 : _t.amountOff) !== null && _u !== void 0 ? _u : 0;
    const shipping = (_z = (_y = (_x = (_w = (_v = cart.shippingAddresses) === null || _v === void 0 ? void 0 : _v[0]) === null || _w === void 0 ? void 0 : _w.selectedShippingMethod) === null || _x === void 0 ? void 0 : _x.amount) === null || _y === void 0 ? void 0 : _y.value) !== null && _z !== void 0 ? _z : 0;
    const appliedTaxes = ((_0 = cart.prices) === null || _0 === void 0 ? void 0 : _0.appliedTaxes) || [];
    const totalNowTax = appliedTaxes.map((tax) => ({
        amount: tax.amount,
        label: tax.label,
    }));
    const total = (_1 = grandTotal === null || grandTotal === void 0 ? void 0 : grandTotal.value) !== null && _1 !== void 0 ? _1 : 0;
    const afterTrialTax = ((_2 = cart.totalAfterTrial) === null || _2 === void 0 ? void 0 : _2.tax) || null;
    const totalAfterTrialTax = [];
    if (afterTrialTax && appliedTaxes.length) {
        totalAfterTrialTax.push({
            amount: afterTrialTax,
            label: "totalAfterTrialTax",
        });
    }
    return {
        currency: (_3 = grandTotal === null || grandTotal === void 0 ? void 0 : grandTotal.currency) !== null && _3 !== void 0 ? _3 : "",
        subtotal,
        deposit,
        shipping,
        total,
        discount,
        totalNowTax,
        totalAfterTrial,
        totalAfterTrialTax,
        totalAfterTrialInclTax,
    };
};
//# sourceMappingURL=mapFreeTrialPriceFromCartPrices.js.map